<template lang="html">
  <div class="reserve-datetime-info">
    <div class="reserve-datetime-info-title pf-medium">预约到店时间</div>
    <div class="datetime-line">
      <div class="datetime-compose" v-if="reserveRecord">
        {{ reserveRecord.reserveDate + ' ' + reserveRecord.reserveTime }}
      </div>
      <div class="modify-btn">
        <div class="datetime-modify" @click="toModifyReserveDateTime">
          改日期
        </div>
        <i class="icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { pushNrNs } from '@/plugins/jump'

export default {
  props: {
    reserveRecord: {
      type: Object,
      default: {}
    },
    order: {
      type: Object,
      default: {}
    }
  },
  methods: {
    toModifyReserveDateTime() {
      this.$router.push({
        name: 'add-reserve',
        query: {
          orderId: this.order.orderId,
          businessId: this.order.businessId,
          reserveId: this.order?.reserveRecord?.id || ''
        }
      })
    }
  },
  computed: {},
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.reserve-datetime-info {
  margin: rem(20px) rem(24px) rem(20px);
  padding: rem(30px) rem(24px) rem(18px) rem(24px);
  border-radius: rem(16px);
  background: #fff;
  .reserve-datetime-info-title {
    font-size: rem(30px);
    padding: 0 0 rem(30px) 0;
  }

  .datetime-line {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .datetime-compose {
      font-size: rem(26px);
      color: #262626;
    }
    .modify-btn {
      display: flex;
      flex-direction: row;
      align-items: center;
      .datetime-modify {
        font-size: rem(26px);
        color: #ff5900;
        margin-right: rem(16px);
      }
      .icon-arrow-right {
        display: inline-block;
        width: 0.2rem;
        height: 0.2rem;
        background-image: url('~@/assets/images/icon-arr-r@3x.png');
        background-size: 0.2rem;
      }
    }
  }
}
</style>
